var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55728 0H14.6241V11.52L8.321 18L7.43675 17.3025C7.34606 17.2275 7.27804 17.1225 7.2327 16.9875C7.18735 16.8525 7.16468 16.6875 7.16468 16.4925V16.2675L8.18496 11.52H1.40573C1.04296 11.52 0.725537 11.385 0.453461 11.115C0.181384 10.845 0.0453461 10.53 0.0453461 10.17V8.325C0.0453461 8.22 0.0340095 8.11125 0.0113365 7.99875C-0.0113365 7.88625 1.68927e-08 7.7775 0.0453461 7.6725L2.90215 1.1475C3.03819 0.8325 3.26114 0.5625 3.571 0.3375C3.88087 0.1125 4.20963 0 4.55728 0ZM13.2637 1.35H4.26253L1.40573 8.0775V10.17H9.86277L8.6611 15.7725L13.2637 10.9575V1.35ZM13.2637 10.9575V1.35V10.9575ZM14.6241 11.52V10.17H17.6396V1.35H14.6241V0H19V11.52H14.6241Z",
    fill: "#FF6161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/Reject.6afe0920b49600ae28f238f2d1e61a25.svg";
export { ForwardRef as ReactComponent };